import { commentsTypes, starTypes, MultiselectTypes } from '../actions/applicantActions';

export default (state = {}, action) => {
  switch (action.type) {
    case commentsTypes.CHANGED_STATE:
      return {
        ...state,
        comments: action.payload,
      };
    case starTypes.POST_STAR:
      return {
        ...state,
        calificacion: action.payload.star,
        history: action.payload.history,
        promedio: action.payload.promedio,
        post: true,
      };
    case starTypes.NOT_STAR:
      return {
        ...state,
        calificacion: action.payload.star,
        history: action.payload.history,
        promedio: action.payload.promedio,
        post: false,
      };
    case MultiselectTypes.POST_CANDIDATE:
      return {
        ...state,
        Array_Candidate_Multiselect: action.payload,
      };
    default:
      return state;
  }
};
